module.exports = __webpack_public_path__ + "static/media/central.4f90e6a3.svg";